<mat-accordion *ngIf="!isImpersonating">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Lista de Usuarios </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Buscador -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar usuario</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Escribe un nombre o usuario">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <!-- Tabla -->
    <div class="mat-elevation-z4 table-container">
      <table mat-table [dataSource]="dataSource" class="full-width-table">

        <!-- Username -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef> Usuario </th>
          <td mat-cell *matCellDef="let user"> {{user.username}} </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let user">
            <button mat-button color="primary"
                    (click)="loginAs(user.username)"
                    [disabled]="isImpersonating">
              Entrar como
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Botón flotante para volver 
 <!--
<button *ngIf="isImpersonating"
        mat-fab
        color="accent"
        class="fab-stop"
        (click)="stop()">
  <mat-icon>logout</mat-icon>
</button>
-->

<!-- Banner de aviso -->
<mat-toolbar color="warn" *ngIf="isImpersonating">
  <span>⚠ Estás actuando como: <b>{{ impersonatedUser }}</b></span>
  <span class="spacer"></span>
  <button mat-button (click)="stop()">Volver a Admin</button>
</mat-toolbar>